import axios from 'axios';

const API_URL = '/api';

export const loginAdmin = async (credentials) => {
    return await axios.post(`${API_URL}/auth/login`, {
        username: credentials.username,
        password: credentials.password
    }, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        withCredentials: true
    });
};
